module.exports = __webpack_public_path__ + "media/images/fondo_corona-48dd72598177d3511b1d8b91755e297d.png";